interface StripeApiError {
  extensions: {
    exception: {
      message: string;
      param?: string;
      path?: string[];
    };
  };
}

export class StripeError extends Error {
  apiResponse: StripeApiError;

  constructor(message: string, apiResponse: StripeApiError) {
    super(message);
    this.apiResponse = apiResponse;
  }
}
